import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import Card from '../../components/ui/Card';
import SafeIcon from '../../common/SafeIcon';

export default function Fleet() {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDrivers = async () => {
      const { data } = await supabase
        .from('profiles')
        .select('*')
        .eq('role', 'driver');
      if (data) setDrivers(data);
      setLoading(false);
    };
    fetchDrivers();
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-brand-navy mb-6">Fleet Management</h1>
      
      {drivers.length === 0 ? (
        <div className="text-center py-20 bg-white rounded-2xl border-2 border-dashed border-gray-200">
          <SafeIcon name="Truck" className="text-4xl text-gray-300 mx-auto mb-4" />
          <p className="text-gray-500 underline decoration-brand-gold decoration-2">No drivers registered yet.</p>
          <p className="text-xs text-gray-400 mt-2">Change a user's role to 'driver' in Supabase to see them here.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {drivers.map(driver => (
            <Card key={driver.id} className="flex flex-col gap-4">
              <div className="flex items-center gap-4">
                <div className="h-12 w-12 bg-brand-navy text-brand-gold rounded-full flex items-center justify-center font-bold">
                  {driver.full_name?.charAt(0)}
                </div>
                <div>
                  <h3 className="font-bold text-lg">{driver.full_name}</h3>
                  <p className="text-sm text-gray-500">{driver.phone || 'No phone'}</p>
                </div>
              </div>
              <div className="flex gap-2">
                <span className="bg-green-100 text-green-700 text-xs px-2 py-1 rounded-full font-medium">Active</span>
                <span className="bg-blue-100 text-blue-700 text-xs px-2 py-1 rounded-full font-medium">On Duty</span>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}